<template>
  <div>
    <div class="title_1_step text-center" v-if="!reservedEnrollment">
      4. ¡Tu matrícula se realizó con éxito!
    </div>

    <div class="icon_success_content" v-if="!reservedEnrollment">
      <div class="icon_success"></div>
      <div class="gray_text" style="margin-top:17px">
        Transacción #{{
          defaultSection.payzen && defaultSection.payzen.transactionId
            ? defaultSection.payzen.transactionId
            : "-"
        }}
      </div>
      <div class="black_text" style="margin-top:7px">
        {{ defaultSection.course_name }}
      </div>

      <br />
      <div class="gray_text">
        El acceso a la plataforma Teams estará disponible 2 horas después de
        realizada su matrícula. Si el inicio de sus clases fuera dentro de 2
        horas o menos, por favor revisar 30 minutos antes o escribir al Centro
        de Ayuda de Pacífico Idiomas a través de este link
        <a href="https://www.up.edu.pe/idiomas/ayuda.aspx"
          >https://www.up.edu.pe/idiomas/ayuda.aspx</a
        >
      </div>

      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="text-center black_text"
      ></v-col>

      <div class="blue_container">
        <div class="black_text" style="font-size:18px;margin-bottom:10px">
          Datos del pago
        </div>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="6">
            <label for class="gray_light">Monto</label>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="6">
            <label for class="gray_text">
              S/
              {{
                defaultSection.payzen && defaultSection.payzen.amount
                  ? defaultSection.payzen.amount
                  : " - "
              }}
            </label>
          </v-col>
          <div class="grayline"></div>
          <v-col cols="12" xs="12" sm="12" md="6">
            <label for class="gray_light">Fecha de operación</label>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="6">
            <label for class="gray_text">
              {{
                defaultSection.payzen && defaultSection.payzen.serverDate
                  ? payDay(defaultSection.payzen.serverDate)
                  : ""
              }}
              {{
                defaultSection.payzen && defaultSection.payzen.serverDate
                  ? payHour(defaultSection.payzen.serverDate)
                  : ""
              }}
            </label>
          </v-col>
          <div class="grayline"></div>
          <v-col cols="12" xs="12" sm="12" md="6">
            <label for class="gray_light">Medio de pago</label>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="6">
            <label for class="gray_text"
              >Tarjeta
              {{
                defaultSection.payzen && defaultSection.payzen.cardBrand
                  ? defaultSection.payzen.cardBrand
                  : " - "
              }}</label
            >
          </v-col>
        </v-row>
      </div>

      <v-col cols="12" xs="12" sm="12" md="12" class="text-left">
        Recibirás el comprobante de pago en las próximas 72hs.
      </v-col>

      <div class="blue_container">
        <div class="black_text" style="font-size:18px;margin-bottom:10px">
          Datos del curso
        </div>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="6">
            <label for class="gray_light">Descripción</label>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="6">
            <label for class="gray_text"
              >{{
                "(" +
                  defaultSection.course_code +
                  ") " +
                  defaultSection.course_name
              }}
            </label>
          </v-col>
          <div class="grayline"></div>
          <v-col cols="12" xs="12" sm="12" md="6">
            <label for class="gray_light">Sede</label>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="6">
            <label for class="gray_text">{{
              defaultSection.campus_name
            }}</label>
          </v-col>
          <div class="grayline"></div>
          <v-col cols="12" xs="12" sm="12" md="6">
            <label for class="gray_light">Modalidad</label>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="6">
            <label for class="gray_text">{{
              defaultSection.modality_name
            }}</label>
          </v-col>
          <div class="grayline"></div>
          <v-col cols="12" xs="12" sm="12" md="6">
            <label for class="gray_light">Frecuencia</label>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="6">
            <label for class="gray_text">{{ defaultSection.frequency }}</label>
          </v-col>
          <div class="grayline"></div>
          <v-col cols="12" xs="12" sm="12" md="6">
            <label for class="gray_light">Horario</label>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="6">
            <label for class="gray_text">{{ defaultSection.schedule }}</label>
          </v-col>
          <div class="grayline"></div>
          <v-col cols="12" xs="12" sm="12" md="6">
            <label for class="gray_light">Fecha de inicio / fin</label>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="6">
            <label for class="gray_text">{{
              defaultSection.start_end_date
            }}</label>
          </v-col>
        </v-row>
      </div>
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="text-center black_text"
      ></v-col>
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="text-center black_text"
      ></v-col>

      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="text-center black_text"
        v-if="defaultSection.free_days && defaultSection.free_days.length > 0"
        >Clases de recuperación</v-col
      >
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="text-center gray_light"
        style="color: #41424F;"
        v-if="defaultSection.free_days && defaultSection.free_days.length > 0"
        >Sesiones del curso distintas de la frecuencia regular:</v-col
      >

      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="gray_light"
        v-if="defaultSection.free_days && defaultSection.free_days.length > 0"
      >
        <ul class="reservestion_confirmation__recover_classes">
          <li v-for="(dayFree, index) in defaultSection.free_days" :key="index">
            {{
              dayFree.day +
                " " +
                dayFree.date +
                " " +
                dayFree.start_hour +
                " - " +
                dayFree.end_hour
            }}
          </li>
        </ul>
      </v-col>

      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="text-center black_text"
      ></v-col>

      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="text-center black_text"
        v-if="
          defaultSection.book &&
            defaultSection.book.book_message &&
            defaultSection.book.book_message != ''
        "
        >Libro</v-col
      >

      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="text-center gray_light"
        style="color: #41424F;margin: 10px 0 0 0;padding: 0;"
        v-if="
          defaultSection.book &&
            defaultSection.book.book_message &&
            defaultSection.book.book_message != ''
        "
      >
        <div v-html="defaultSection.book.book_message"></div>
      </v-col>

      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="text-center black_text"
      ></v-col>

      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="light-gray-text"
        style="margin: 50px 0 20px 0;padding: 0;"
        >Normas académicas y Administrativas</v-col
      >

      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="light-gray-text"
        style="font-size:15px;margin: 20px 0 5px 0;padding: 0;"
        >Te recomendamos leer las normas académicas y administrativas del</v-col
      >

      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="light-gray-text"
        style="font-size:15px;margin: 5px 0 50px 0;padding: 0;"
      >
        inicio de tus clases el cual puedes encontrar
        <a
          href="https://campusvirtual.up.edu.pe/pdf/cidup-reglamento-academico-administrativo-enero-diciembre-2021.pdf"
          target="_blank"
          >aquí</a
        >
      </v-col>

      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="light-gray-text"
        style="margin: 50px 0 20px 0;padding: 0;"
        >Hoja informativa</v-col
      >

      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="light-gray-text"
        style="font-size:15px;margin: 20px 0 5px 0;padding: 0;"
        >Te recomendamos leer la hoja informativa antes del</v-col
      >

      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="light-gray-text"
        style="font-size:15px;margin: 5px 0 30px 0;padding: 0;"
      >
        inicio de tus clases el cual puedes encontrar
        <a
          href="https://campusvirtual.up.edu.pe/pdf/hoja-informativa-sobre-normas-administrativas.pdf"
          target="_blank"
          >aquí</a
        >
      </v-col>

      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="text-center black_text"
      ></v-col>
      <v-btn color="primary" class="btn-basic uppercase" @click="goHome"
        >Ir al inicio</v-btn
      >
    </div>

    <!-- <div
      class="text_info text-center"
      v-if="reservedEnrollment && defaultSection.expiration_date"
    >
      Tu fecha limite de pago es hasta
    </div>
    <div
      class="text_info text-center"
      v-if="reservedEnrollment && defaultSection.expiration_date"
    >
      las 23:59hs del día {{ defaultSection.expiration_date }}
    </div> -->
    <div
      class="text_info text-center"
      v-if="reservedEnrollment && defaultSection.expiration_date"
    >
      Tienes 24 horas para realizar el pago
    </div>
    <hr />
    <div
      class="text_info text-center"
      v-if="reservedEnrollment && defaultSection.expiration_date"
    >
      Si elegiste la opción de pago en banco, ten presente que solo podrás
      ingresar a clases siempre y cuando hayas cancelado los derechos
      académicos.
    </div>

    <v-row v-if="reservedEnrollment" class="reservestion_confirmation">
      <v-col cols="12" xs="12" sm="12" md="12" align="center" justify="center">
        <img src="@/assets/images/Vector.svg" alt />
      </v-col>
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        align="center"
        justify="center"
        class="reservestion_confirmation__pament_info title_1_step"
      >
        Realiza el pago con tu
        <span class="text_bold">Código de Alumno</span>
        a través de tu banca por internet o en cualquier agencia
        <span class="text_bold">BCP, Interbank, BBVA y Scotiabank</span>
      </v-col>

      <div class="code_container mb-6">
        <div class="mr-2">Código de Alumno:</div>
        <v-tooltip bottom ref="tooltip">
          <template v-slot:activator="{ on }">
            <div @click="copyCode" v-on="on" style="display: flex;">
              <div class="code">{{ studentCode }}</div>
              <v-icon class="copy_icon">mdi-content-copy</v-icon>
            </div>
          </template>
          <span>{{ tooltipText }}</span>
        </v-tooltip>
      </div>

      <div class="blue_container reservestion_confirmation__blue_contaner">
        <div class="black_text" style="font-size:18px;margin-bottom:10px">
          Datos del curso
        </div>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="6">
            <label for class="gray_light">Descripción</label>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="6">
            <label for class="gray_text"
              >{{
                "(" +
                  defaultSection.course_code +
                  ") " +
                  defaultSection.course_name
              }}
            </label>
          </v-col>
          <div class="grayline"></div>
          <v-col cols="12" xs="12" sm="12" md="6">
            <label for class="gray_light">Sede</label>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="6">
            <label for class="gray_text">{{
              defaultSection.campus_name
            }}</label>
          </v-col>
          <div class="grayline"></div>
          <v-col cols="12" xs="12" sm="12" md="6">
            <label for class="gray_light">Modalidad</label>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="6">
            <label for class="gray_text">{{
              defaultSection.modality_name
            }}</label>
          </v-col>
          <div class="grayline"></div>
          <v-col cols="12" xs="12" sm="12" md="6">
            <label for class="gray_light">Frecuencia</label>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="6">
            <label for class="gray_text">{{ defaultSection.frequency }}</label>
          </v-col>
          <div class="grayline"></div>
          <v-col cols="12" xs="12" sm="12" md="6">
            <label for class="gray_light">Horario</label>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="6">
            <label for class="gray_text">{{ defaultSection.schedule }}</label>
          </v-col>
          <div class="grayline"></div>
          <v-col cols="12" xs="12" sm="12" md="6">
            <label for class="gray_light">Fecha de inicio / fin</label>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="6">
            <label for class="gray_text">{{
              defaultSection.start_end_date
            }}</label>
          </v-col>
        </v-row>
      </div>

      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="text-center black_text"
        v-if="defaultSection.free_days && defaultSection.free_days.length > 0"
        >Clases de recuperación</v-col
      >
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="text-center gray_light"
        style="color: #41424F;"
        v-if="defaultSection.free_days && defaultSection.free_days.length > 0"
        >Sesiones del curso distintas de la frecuencia regular:</v-col
      >

      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="gray_light"
        v-if="defaultSection.free_days && defaultSection.free_days.length > 0"
      >
        <ul class="reservestion_confirmation__recover_classes">
          <li v-for="(dayFree, index) in defaultSection.free_days" :key="index">
            {{
              dayFree.day +
                " " +
                dayFree.date +
                " " +
                dayFree.start_hour +
                " - " +
                dayFree.end_hour
            }}
          </li>
        </ul>
      </v-col>

      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="text-center black_text"
      ></v-col>

      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="text-center black_text"
        v-if="
          defaultSection.book &&
            defaultSection.book.book_message &&
            defaultSection.book.book_message != ''
        "
        >Libro</v-col
      >

      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="text-center gray_light"
        style="color: #41424F;margin: 10px 0 0 0;padding: 0;"
        v-if="
          defaultSection.book &&
            defaultSection.book.book_message &&
            defaultSection.book.book_message != ''
        "
      >
        <div v-html="defaultSection.book.book_message"></div>
      </v-col>
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="text-center info_text"
        style="margin:30px 0 0 0;padding:0"
      ></v-col>
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="text-center info_text"
        style="margin:30px 0 0 0;padding:0"
        >Si tienes dudas o inquietudes, por favor comunícate con nosotros a
        través de los siguientes contactos:</v-col
      >
      <v-col cols="12" xs="12" sm="12" md="12" align="center" justify="center">
        <span style="font-weight:bold; font-size:16px"
          >Atención al estudiante (consultas y servicios):</span
        >
      </v-col>
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="text-center info_text"
        style="margin:0 0 40px 0;padding:0"
      >
        Teléfono:
        <span style="font-weight:bold">(01) 219-0152</span> / Anexo 5217 E-mail:
        <span style="font-weight:bold"
          ><a href="mailto:idiomas.miraflores@up.edu.pe"
            >idiomas.miraflores@up.edu.pe</a
          ></span
        >
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="12" align="center" justify="center">
        <span style="font-weight:bold; font-size:16px"
          >Asistencia técnica para conectarte a tus clases:</span
        >
      </v-col>
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="text-center info_text"
        style="margin:0 0 40px 0;padding:0"
      >
        Teléfono:
        <span style="font-weight:bold">(01) 219-0100</span> / Anexo 8804 -
        E-mail:
        <span style="font-weight:bold"
          ><a href="mailto:asistentetec.idiomas@up.edu.pe"
            >asistentetec.idiomas@up.edu.pe</a
          ></span
        >

        - 

        <span style="font-weight:bold"
          ><a href="https://wa.me/51965438747" target="_blank"
            >965438747<v-icon style="color:#25D366">mdi-whatsapp</v-icon></a
          ></span
        >
      </v-col>
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="text-center info_text"
        style="margin:0 0 40px 0;padding:0"
      >
      Horario de atención de:
      <br>Lunes a Viernes de 6:50 a.m. a 10:15 p. m.
      <br>Sábado de 7:30 a. m. a 6:00 p.m.
      <br> Domingo de 08:15 a.m. a 11:30 a.m.
      </v-col>
      <!-- <v-col cols="12" xs="12" sm="12" md="12" class="text-center info_text">
                  Esta información se la enviaremos al correo electrónico
                  <span
                    class="text_blue"
                  >jcastro@gmail.com</span>
                </v-col>

                <v-col
                  cols="12"
                  xs="12"
                  sm="12"
                  md="12"
                  style="margin:20px 0 60px 0;display:flex;justify-content:center"
                >
                  <v-btn
                    outlined
                    class="ma-2 btn-basic"
                    color="primary"
                    @click="updateEmail=true"
                  >Actualizar tu Correo</v-btn>
                </v-col> -->

      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="text-center black_text"
      ></v-col>
      <!-- <v-col
                  cols="12"
                  xs="12"
                  sm="12"
                  md="12"
                  class="text-center gray_text"
                  style="color:#A6A6A6;margin-bottom:10px"
                >Estacionamiento</v-col> -->
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="light-gray-text"
        style="margin: 50px 0 20px 0;padding: 0;"
        >Normas académicas y Administrativas</v-col
      >

      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="light-gray-text"
        style="font-size:15px;margin: 20px 0 5px 0;padding: 0;"
        >Te recomendamos leer las normas académicas y administrativas antes del</v-col
      >

      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="light-gray-text"
        style="font-size:15px;margin: 5px 0 30px 0;padding: 0;"
      >
        inicio de tus clases el cual puedes encontrar
        <a
          href="https://campusvirtual.up.edu.pe/pdf/cidup-reglamento-academico-administrativo-enero-diciembre-2021.pdf"
          target="_blank"
          >aquí</a
        >
      </v-col>

      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="light-gray-text"
        style="margin: 50px 0 20px 0;padding: 0;"
        >Hoja informativa</v-col
      >

      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="light-gray-text"
        style="font-size:15px;margin: 20px 0 5px 0;padding: 0;"
        >Te recomendamos leer la hoja informativa antes del</v-col
      >

      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="light-gray-text"
        style="font-size:15px;margin: 5px 0 30px 0;padding: 0;"
      >
        inicio de tus clases el cual puedes encontrar
        <a
          href="https://campusvirtual.up.edu.pe/pdf/hoja-informativa-sobre-normas-administrativas.pdf"
          target="_blank"
          >aquí</a
        >
      </v-col>

      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="text-center text_blue"
        style="margin-bottom: 70px"
        ><!-- Políticas de estacionamiento y valet parking --></v-col
      >

      <v-col cols="12" xs="12" sm="12" md="12" align="center" justify="center">
        <v-btn color="primary" class="btn-basic uppercase" @click="goHome"
          >Ir al inicio</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "success-enrollment",
  data() {
    return {
      tooltip: false,
      tooltipText: "Copiar Código"
    };
  },
  mounted() {
    this.enviarEvento();
  },
  props: ["step"],
  methods: {
    enviarEvento() {
      if (typeof window.gtag === 'function') {
        window.gtag('event', '4 - Resumen pago - matrícula', {
          'event_category': 'Matricula'
        });
      }
    },
    payDay(str) {
      let date = new Date(str);
      return (
        date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()
      );
    },
    payHour(str) {
      let date = new Date(str);
      return (
        date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds()
      );
    },
    goHome() {
      this.$router.push("/principal");
    },
    copyCode() {
      navigator.clipboard
        .writeText(this.studentCode)
        .then(() => {
          this.tooltipText = "Copiado";
          setTimeout(() => {
            this.tooltipText = "Copiar Código";
          }, 2000);
        })
        .catch(error => {
          console.error("Error al copiar al portapapeles: ", error);
        });
    }
  },
  computed: {
    ...mapState(["defaultSection", "bankPay"]),

    reservedEnrollment() {
      return this.defaultSection.paymentType == "bank" ? true : false;
    },
    studentCode() {
      return this.user.student_code.slice(1);
    }
  },
  created() {
    this.user = this.$store.state.usuario;
  }
};
</script>
